import React from 'react';
import { Link } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
const GlobalStyle = createGlobalStyle`
 @media all and (max-width: 768px) {.login-container{
background:transparent !important}}`;
const CreatePasswordContent = ({ isForgotFlow }) => {
  return (
    <Wrapper className="content-box-wrapper">
      <GlobalStyle />
      <span className="heading">
        {isForgotFlow ? (
          <>
            {' '}
            Update your
            <b>password</b>
          </>
        ) : (
          <>
            {' '}
            Set Your
            <b>Password</b>
          </>
        )}
      </span>
      <p className="sub-title">
        For added security, change your password regularly and avoid reusing old
        ones.
      </p>
      <img src="/images/create_password.png" className={`gpk`} alt="Graphic" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .heading {
    b {
      display: block;
    }
  }
  .gpk {
    position: relative;
    bottom: 20px;
    z-index: -1;
    width: 75%;
    max-width: 350px;
    margin-top: 60px;
    display: block !important;
  }
  @media all and (max-width: 768px) {
    .gpk {
      margin: auto;
      margin-top: 40px;
      z-index: 1;
    }
  }
  @media all and (max-width: 520px) {
    .gpk {
      max-width: 200px;
      margin: auto;
      margin-top: 40px;
      z-index: 1;
    }
    .heading {
      b {
        display: inline-block;
        padding-left: 6px;
      }
    }
  }
`;

export default CreatePasswordContent;
